/*
 * 部分全局常量通过此文件导出，避免分散在每个文件中
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-31 14:49:59
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2021-07-27 12:10:47
 */

import STORAGE from './storage';
import MenuIcons from './menuIcons';
import MockMenu from './mockMenu';
import HomeContext from './home-context';
import PRIVILEGE_MAP from './privilege';
import MallMockMenu from './mockMenu_mall';

// 商城和店铺的字段名
const SOURCE_FIELD_STORE = 'storeNo';
const SOURCE_FIELD_MALL = 'mallNo';
const { COMMENT, COMMODITY, ORDER, STORE, STAFF, TRADE, DEVICE, ACCOUNT, BUSINESS, MALL, SETTLE } = PRIVILEGE_MAP;

// 各个模块查看权限的ID
const PRIVILEGE_VIEW_LIST = [
	COMMENT.EVALUATE_VIEW,
	COMMODITY.COMMODITY_VIEW,
	ORDER.ORDER_VIEW,
	ORDER.REFUND_VIEW,
	ACCOUNT.ACCOUNT_HOMEPAGE_OVERVIEW,
	ACCOUNT.TRADE_DETAIL_OVERVIEW,
	ACCOUNT.FINANCE_DETAIL_OVERVIEW,
	TRADE.TRADE_OVERVIEW,
	BUSINESS.BUSINESS_ACTIVITY_OVERVIEW,
	BUSINESS.BUSINESS_COUPON_OVERVIEW,
	DEVICE.DEVICE_VIEW,
	DEVICE.CASHIER_VIEW,
	STAFF.STORE_USER_MANAGEMENT,
	STORE.STORE_VIEW,
	STORE.STATION_VIEW,
	STORE.BOOKING_MANAGEMENT,
	STORE.STALL_VIEW,
	STORE.TABLE_NO,
	STORE.SCAN_WRITE_OFF,
	SETTLE.MALL_SETTLE_MERCHANT_BILL_VIEW,
	SETTLE.STORE_SETTLED_MERCHANT_BILL_VIEW,
	MALL.MALL_TRADE_OVERVIEW,
	MALL.MALL_STORE_VIEW,
	MALL.MALL_ORDER_VIEW
];

export {
	STORAGE,
	MenuIcons,
	MockMenu,
	MallMockMenu,
	HomeContext,
	PRIVILEGE_MAP,
	SOURCE_FIELD_STORE,
	SOURCE_FIELD_MALL,
	PRIVILEGE_VIEW_LIST
};
